import React from 'react';
import { ListItem, ListItemText } from 'material-ui/List';

const CheckinCdItem = ({ data }) => {
    let payload = data.payload;
    const value = JSON.parse(payload.value);

    const openMap = e => {
        const lat = value.latitude;
        const lng = value.longitude;

        window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank');
    }

    return (
        <ListItem onClick={openMap} button>
            <i className="material-icons" style={{color: '#35ec62'}}>pin_drop</i>
            <ListItemText primary={'Realizou check in no Centro de Distribuição'} />
        </ListItem>
    );

}

export default CheckinCdItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/CheckinCd.js